import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, NO_ACCESS_MESSAGE, hasAnyRequiredActionsInAnySpace } from "utils/access";
import { Action } from "types/generated";

const TEST_TEMPLATE_DEPLOYMENT_ACCESS_TYPES = [
  Action.SpaceAdmin,
  Action.TestBlueprintDeployment,
];

/**
 * Hook that returns whether current user can create test template deployments (for draft versions)
 * User needs to be an admin or have SpaceAdmin or TestBlueprintDeployment action in at least one space
 * @returns {AccessResult} Object indicating if user can create test template deployment and a message if not
 */
const useCanTestTemplateDeployment = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasAnyRequiredActionsInAnySpace(TEST_TEMPLATE_DEPLOYMENT_ACCESS_TYPES, viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanTestTemplateDeployment;
